/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonSharedBusinessSectorDropdownQueryResponse,
  GetApiV1PersonSharedBusinessSectorDropdown401,
  GetApiV1PersonSharedBusinessSectorDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedBusinessSectorDropdown.ts";

function getGetApiV1PersonSharedBusinessSectorDropdownUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/person/shared/business-sector-dropdown` as const,
  };
  return res;
}

/**
 * @description Retorna todos os setores de negócio cadastrados, com nome resolvido pelo idioma configurado, ordenados por ID. **(Requer Authorization para autenticação)**
 * @summary Lista de setores de negócio para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/business-sector-dropdown}
 */
export async function getApiV1PersonSharedBusinessSectorDropdown(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonSharedBusinessSectorDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedBusinessSectorDropdown401
      | GetApiV1PersonSharedBusinessSectorDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonSharedBusinessSectorDropdownUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
